import { ITranslationOverlay } from '../Language/Language';

export interface IFileReference {
  id: string,
  createdAt: number,
  copyright: string,
  internalInfo: string,
  origin: string,
  mimetype: string,
  originPath: string,
  sorting: number,
  size: number,

  overlayTexts?: { field: string, text: string, languageId: string }[],
}


export class FileReference {

  public id: string;
  public createdAt: Date;
  public copyright: string;
  public internalInfo: string;
  public origin: string;
  public mimetype: string;
  public originPath: string;
  public sorting: number;
  public size: number;
  public textOverlay?: Record<string, ITranslationOverlay>;

  constructor(data: IFileReference) {

    this.id = data.id;
    this.createdAt = new Date(data.createdAt * 1000);
    this.copyright = data.copyright;
    this.internalInfo = data.internalInfo;
    this.origin = data.origin;
    this.mimetype = data.mimetype;
    this.originPath = data.originPath;
    this.sorting = data.sorting;
    this.size = data.size;

    this.textOverlay = {};

    if(data.overlayTexts) {
      data.overlayTexts.forEach(entry => {
        this.textOverlay![entry.languageId] = {
          ...(this.textOverlay![entry.languageId] || {}),
          [entry.field]: entry.text,
        };
      })
    }
  }
}
